import styled from 'styled-components';

export const Container = styled.div`
  canvas.react-pdf__Page__canvas {
    margin: auto;
    margin-top: 20px;
  }
`;

export const TitleAcess = styled.p`
  text-align: center;
  font-size: 16px;
  font-weight: normal;
  letter-spacing: 0px;
  color: #2e384d;
  opacity: 1;
  margin: 110px 0;

  @media (max-width: 759px) {
    margin: 110px 0 65px 0px;
  }
`;

export const AlertContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const TitleMessage = styled.span`
  text-align: left;
  font-size: 14px;
  letter-spacing: 0px;
  color: #ed4343;
  opacity: 1;
  margin: 0 0 0 10px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  max-width: 757px;
  margin: 0 auto;

  @media (max-width: 801px) {
    margin: ${(props) => props.theme.spacing.base};
    flex-direction: column;
    justify-content: center;

    button {
      width: 100%;
      margin: ${(props) => props.theme.spacing.tiny} 0;
    }
  }
`;

export const VerificaButtonOld = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const DocumentsDownload = styled.div`
  width: ${(props) => props.width};
  height: 45px;
  background: ${(props) => props.backgroundColor};
  border: 1px solid ${(props) => props.borderColor};
  border-radius: 4px;
  opacity: 1;
  color: ${(props) => props.textColor};
  margin-left: ${(props) => props.marginLeft};
  text-align: center;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0px;
  text-transform: uppercase;
  opacity: 1;
  transition: all 0.3s ease 0s;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 8px;

  :hover {
    box-shadow: 5px 5px 15px 5px #d6d6d6;
  }
`;

export const PdfContainer = styled.div`
  background: gray;
  display: flex;
  max-width: 100vw;
  height: 404px;
  flex-direction: column;
  flex-wrap: nowrap;
  -webkit-overflow-scrolling: touch;
  overflow-x: scroll;
`;

export const ButtonBox = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin: 30px 0;
`;

export const ButtonClose = styled.button`
  width: 122px;
  height: 45px;
  background: #2699fb;
  border-radius: 4px;
  border: none;
  opacity: 1;
  text-align: center;
  font-size: 14px;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
  font-weight: bold;
`;

export const DownloadButton = styled.button`
  width: 200px;
  height: 45px;
  background: #fff;
  border: 2px solid #2699fb;
  border-radius: 4px;
  opacity: 1;
  text-align: center;
  font-size: 12px;
  letter-spacing: 0px;
  text-transform: uppercase;
  opacity: 1;
  margin-right: 20px;

  a:link {
    text-decoration: none;
    color: #2699fb;
    font-weight: bold;
  }

  a:visited {
    color: #2699fb;
  }
`;

export const TextData = styled.span`
  color: #78849e;
  font-size: 14px;
  text-align: left;
  letter-spacing: 0px;
  opacity: 1;
  margin-bottom: ${(props) => props.marginBottom};
`;

export const ButtonRecipe = styled.button`
  width: ${(props) => props.width};
  height: 45px;
  background: ${(props) => props.backgroundColor};
  border: 1px solid ${(props) => props.borderColor};
  border-radius: 4px;
  opacity: 1;
  color: ${(props) => props.textColor};
  margin-left: ${(props) => props.marginLeft};
  text-align: center;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0px;
  text-transform: uppercase;
  opacity: 1;
  transition: all 0.3s ease 0s;
  :hover {
    box-shadow: 5px 5px 15px 5px #d6d6d6;
  }
`;
